import Queries from '../queries';

const {
    GET_MODALS,
} = Queries;

const Mutation = {
    modalShow: (_root, { name }, { client }) => {

        const { modals } = client.readQuery({ query: GET_MODALS });
        const state = JSON.parse(modals);
        const newState = {
            ...state,
            [name]: true,
        };

        client.writeQuery({
            query: GET_MODALS,
            data: {
                modals: JSON.stringify(newState),
            },
        });

        return null;

    },
    modalHide: (_root, { name }, { client }) => {

        const { modals } = client.readQuery({ query: GET_MODALS });
        const state = JSON.parse(modals);
        const newState = {
            ...state,
            [name]: false,
        };

        client.writeQuery({
            query: GET_MODALS,
            data: {
                modals: JSON.stringify(newState),
            },
        });

        return null;

    },
    modalToggle: (_root, { name }, { client }) => {

        const { modals } = client.readQuery({ query: GET_MODALS });
        const state = JSON.parse(modals);
        const newState = {
            ...state,
            [name]: !state[name],
        };

        client.writeQuery({
            query: GET_MODALS,
            data: {
                modals: JSON.stringify(newState),
            },
        });

        return null;

    },
};

export const resolvers = {
    Mutation,
};

export const constants = {
    REEL_MODAL_NAME: 'REEL_MODAL_NAME',
    SHARE_MODAL_NAME: 'SHARE_MODAL',
    REEL_CREATION_MODAL_NAME: 'REEL_CREATION_MODAL',
    TRIM_REEL_CLIP_MODAL_NAME: 'TRIM_REEL_CLIP_MODAL',
    MENU_MODAL_NAME: 'MENU_MODAL',
    FILTER_MODAL_NAME: 'FILTER_MODAL',
    DELETE_REEL_MODAL_NAME: 'DELETE_REEL_MODAL',
    SEARCH_SORT_MODAL_NAME: 'SEARCH_SORT_MODAL',
};
